module.exports = __webpack_public_path__ + "img/LIGHTING 1 LIME.580ca34.svg";